import { Component, Inject } from '@angular/core';
import { FIRST_AVAILABLE_STAFF_ID, Staff } from '../../../models';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { LibCoreLayoutModule } from '../../index';
import { PipesModule } from '../../../pipes';
import { MatButtonModule } from '@angular/material/button';

export interface StaffSelectionDialogComponentData {
  staffs: Staff[];
  currentSelectedStaffId?: number;
}

@Component({
  selector: 'lib-staff-selection-dialog',
  templateUrl: './staff-selection-dialog.component.html',
  styleUrls: ['./staff-selection-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    LibCoreLayoutModule,
    PipesModule,
    TranslateModule,
    // material design
    MatButtonModule,
  ],
})
export class StaffSelectionDialogComponent {
  public readonly FIRST_AVAILABLE_STAFF_ID = FIRST_AVAILABLE_STAFF_ID;

  public staffs: Staff[];
  private readonly currentSelectedStaffId: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: StaffSelectionDialogComponentData,
    private dialogRef: MatDialogRef<StaffSelectionDialogComponent>
  ) {
    this.staffs = this.data?.staffs;
    this.currentSelectedStaffId = this.data?.currentSelectedStaffId;
  }

  public isStaffSelected(staffId: number): boolean {
    return staffId === this.currentSelectedStaffId;
  }

  public selectStaff(staffId: number) {
    this.dialogRef.close(staffId);
  }

  public closeDialog(): void {
    this.dialogRef.close(null);
  }
}
